import { render } from "./EnjoySports.vue?vue&type=template&id=36b89946&ts=true"
import script from "./EnjoySports.vue?vue&type=script&lang=ts"
export * from "./EnjoySports.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__